import * as React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {Option, option} from "ts-option";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import Toast from "../../helper/Toast";
import Job from "../../../model/job/Job";
import JobStatus from "../../../model/job/JobStatus";
import SelectJobStatus from "./SelectJobStatus";
import {fetchJobEvents, updateJobStatus} from "../../../store/action/job/job";
import {getLoggedUser} from "../../../store/view/user";
import {UserPermission} from "../../../model/user/UserPermission";
import {RootState} from "../../../store/reducer/root/RootState";

interface IComponentProps {
	/**
	 * Job.
	 */
	job: Job;
	/**
	 * Indicates if a status can be searched for by typing; a phone's keyboard would cover the list.
	 */
	searchable?: boolean;
}

interface IDispatchProps {
	/**
	 * Update job status.
	 * @param {string} jobId job Id to be updated.
	 * @param {string} status New lead status.
	 * @param {OnSuccess} onSuccess Success callback.
	 * @param {OnFailure} onFailure Failure callback.
	 */
	updateJobStatus: (jobId: string, status: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Fetch job history.
	 * @param {string} jobId job identifier.
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchJobHistory: (jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	isPaid: boolean
}

type Props = IComponentProps & IDispatchProps & ReduxProps;

class JobStatusSelector extends React.Component<Props> {

	constructor(props: Props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
			<div className={"c-job-status-selector"}>
				<SelectJobStatus
					selectedId={option(this.props.job.statusId)}
					clearable={false}
					searchable={this.props.searchable}
					onChanged={this.handleChange}
					disabled={getLoggedUser().map(user => !user.hasPermissions([UserPermission.JobStatusUpdate])).getOrElse(true)}
					isJobInvoiceOrBillPaid={this.props.isPaid}
				/>
			</div>
		);
	}

	/**
	 * Handle status change.
	 * @param {string} selectedStatus New job status id.
	 */
	handleChange(selectedStatus: Option<JobStatus>) {
		selectedStatus.map((status: JobStatus) => {
			if (status.id != this.props.job.statusId) {
				this.props.updateJobStatus(
					this.props.job.id,
					status.id,
					() => {
						this.props.fetchJobHistory(this.props.job.id, () => {}, () => {});
					},
					() => Toast.error("Could not update Job status", "Job update error"))
			}
		});
	}

}

function mapStateToProps(state: RootState, props: Props): ReduxProps {
	const jobId = props.job.id
	const bill = state.bill.billsByJobIdMap[jobId]
	const invoice = state.invoice.invoicesMap[jobId]
	const isPaid = (bill && bill.isPaid()) || (invoice && invoice.isPaid())
	return {isPaid}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateJobStatus: (jobId: string, status: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateJobStatus(jobId, status, onSuccess, onFailure)),
		fetchJobHistory: (jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(fetchJobEvents(jobId, onSuccess, onFailure))
	}
}

export default connect<ReduxProps, IDispatchProps, IComponentProps>(mapStateToProps, mapDispatchToProps)(JobStatusSelector);